<div class="row">
    <div class="py-3 px-5 main-container bg-white d-flex justify-content-center align-items-center">
<span class="primary mr-2">
        Saving
      </span>
      <ui-loading-balls [loading]="true" ></ui-loading-balls>
    </div>
  </div>